import { ApiError, parseApiError } from './apiError'
import notifyServerError from './notifyServerError'

export default function reportApiFailure(error: unknown, notifyFallback: (apiError: ApiError) => void) {
  const apiError = parseApiError(error)
  if (apiError.reason === 'serverError' && apiError.traceId) {
    notifyServerError(apiError.traceId)
  } else {
    notifyFallback(apiError)
  }
}
